import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { FolderType } from 'stores/Folders/types';

import {
  FolderItem,
  ExpandIcon,
  FolderName,
  FolderItemContent,
  StyledSelectedFolderIcon,
  StyledDefaultFolderIcon,
} from './styles';

interface FolderTreeSelectItemProps {
  folder: FolderType;
  depth: number;
  selectedFolderId: string | null;
  expandedFolderIds: Set<string>;
  onSelect: (folderId: string) => void;
  onToggleExpand: (folderId: string) => void;
}

const FolderTreeSelectItem: React.FC<FolderTreeSelectItemProps> = ({
  folder,
  depth,
  selectedFolderId,
  expandedFolderIds,
  onSelect,
  onToggleExpand,
}) => {
  const isSelected = selectedFolderId === folder.uuid;
  const isExpanded = expandedFolderIds.has(folder.uuid);
  const hasSubfolders = folder.subfolders && folder.subfolders.length > 0;

  const handleClick = (): void => {
    onSelect(folder.uuid);
  };

  const handleExpandClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onToggleExpand(folder.uuid);
  };

  return (
    <>
      <FolderItem $depth={depth} onClick={handleClick}>
        <ExpandIcon $visible={hasSubfolders} $expanded={isExpanded} onClick={handleExpandClick}>
          <ExpandMoreIcon fontSize="small" />
        </ExpandIcon>
        <FolderItemContent $selected={isSelected}>
          {isSelected ? <StyledSelectedFolderIcon fontSize="small" /> : <StyledDefaultFolderIcon fontSize="small" />}
          <FolderName $selected={isSelected}>{folder.name}</FolderName>
        </FolderItemContent>
      </FolderItem>
      {isExpanded &&
        hasSubfolders &&
        folder.subfolders.map((subfolder) => (
          <FolderTreeSelectItem
            key={subfolder.uuid}
            folder={subfolder}
            depth={depth + 1}
            selectedFolderId={selectedFolderId}
            expandedFolderIds={expandedFolderIds}
            onSelect={onSelect}
            onToggleExpand={onToggleExpand}
          />
        ))}
    </>
  );
};

export default FolderTreeSelectItem;
